// Can be set in webpack.common.js or directly
// as env-variable in build stage
export const getDSN = () => process.env.SENTRY_DSN || '<sentry dns placeholder>';

/**
 * Gathers relevant parameters used by sentry
 * to properly segment new issues and re
 * */
export const getParams = () => ({
  environment: process.env.NODE_ENV,
  release: process.env.RELEASE_VERSION,
});
